import PromoBlock from "@components/PromoBlock"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulPromoBlockProps extends ContentfulContentBaseProps {}

const ContentfulPromoBlock = ({
  blockId,
  cta,
  header,
  links,
}: ContentfulPromoBlockProps) => (
  <PromoBlock blockId={blockId} cta={cta} header={header} links={links} />
)

export default ContentfulPromoBlock
